import React, { useEffect, useState } from "react";
import { useProductInfoModal } from "../stores/productModalStore";

import styles from "./ProductSummary.module.scss";

import { ReactComponent as ChevronIcon } from "../assets/chevronIcon.svg";
import OrderDetails from "./OrderDetails";

function ProductSummary() {
  const [showHeaderShadow, setShowHeaderShadow] = useState(false);
  const { showProductInfoModal, setShowProductInfoModal } =
    useProductInfoModal();

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 0) {
        setShowHeaderShadow(true);
      } else {
        setShowHeaderShadow(false);
      }
    }

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.container}>
      <header
        className={`${styles.mobileHeader} ${
          showHeaderShadow ? styles.active : ""
        }`}
      >
        <div className={styles.container}>
          <div></div>
          <div
            className={styles.details}
            onClick={() => {
              setShowProductInfoModal(showProductInfoModal ? false : true);
            }}
          >
            <span className={styles.caption}>
              {showProductInfoModal ? "Close" : "Details"}
            </span>

            <div
              className={`${styles.iconWrapper} ${
                showProductInfoModal ? styles.active : ""
              }`}
            >
              <ChevronIcon />
            </div>
          </div>
        </div>
      </header>

      <div className={styles.productSummary}>
        <div className={styles.header}>
          <div
            className={styles.productImageContainer}
            onClick={() => {
              setShowProductInfoModal(true);
            }}
          >
            <img
              className={styles.heroImage}
              src="https://d1wqzb5bdbcre6.cloudfront.net/c25a949b6f1ffabee9af1a5696d7f152325bdce2d1b926456d42994c3d91ad78/68747470733a2f2f66696c65732e7374726970652e636f6d2f6c696e6b732f666c5f746573745f67625631776635726a4c64725a635858647032346d643649"
              alt="Product"
              loading="lazy"
            />

            <div className={styles.itemCount}>3 items</div>
          </div>

          <div className={styles.name}>Pay Powdur</div>

          <div className={styles.totalSum}>$55.00</div>
        </div>

        <section className={styles.orderDetails}>
          <OrderDetails />
        </section>
      </div>
    </div>
  );
}

export default ProductSummary;
